import { StationListDOI } from 'src/pages/stationList/api/stationListApi';

/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:54 2020/10/16
 */

interface StationDetailVOI {
	currentStation: StationListDOI.RowDataI
}

let state: StationDetailVOI = {
    // @ts-ignore
	currentStation: {}
}
const stationDetail = {
	namespaced: true,
	state: state,
	mutations: {
		saveCurrentStation(state: StationDetailVOI, data) {
			state.currentStation = data
		},
	}
}

export default stationDetail